/**
 * A form multi-line text input.
 */

import {TailwindContents} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import React, {type TextareaHTMLAttributes} from 'react';

export const TextArea = ({
  className,
  ...props
}: TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  return (
    <TailwindContents>
      <textarea
        className={clsx(
          'h-full w-full flex-1',
          'p-8 leading-6',
          'focus:outline-none',
          'dark:bg-moon-900 dark:selection:bg-moon-650',
          'dark:text-moon-200  dark:selection:text-moon-200',
          'relative bottom-0 top-0 items-center rounded-sm',
          'outline outline-1 outline-moon-250 dark:outline-moon-700 focus-within:outline-wb-border-field-focus',
          props.disabled
            ? 'opacity-50'
            : 'hover:outline hover:outline-2 hover:outline-wb-border-field-hover focus:outline-2',
          'outline outline-1 outline-moon-250 hover:outline-wb-border-field-hover focus:outline-wb-border-field-focus',
          'appearance-none border-none',
          'placeholder-[light-dark(var(--moon-500),_var(--moon-450))]',
          className
        )}
        {...props}
      />
    </TailwindContents>
  );
};
